import Modal from 'components/Modal';
import Typography from 'components/Typography';
import {Insurance} from 'types/insurance';
import styles from './InsuranceModal.module.scss';
import ImageView from 'components/ImageView';
import {useState} from 'react';
import Card from 'components/Card';
import CardContent from 'components/CardContent';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  insurance?: Insurance;
}

function InsuranceModal({isOpen, onClose, insurance}: Props) {
  // const defaultImages = {
  //   front_image: {
  //     medium:
  //       'https://images.unsplash.com/photo-1449034446853-66c86144b0ad?w=620&auto=format&fit=crop&q=60&ixlib=rb-4.1.0',
  //   },
  //   back_image: {
  //     medium:
  //       'https://images.unsplash.com/photo-1503803548695-c2a7b4a5b875?w=620&auto=format&fit=crop&q=60&ixlib=rb-4.1.0',
  //   },
  // };
  const insuranceId = insurance?.id;
  const front_image = insurance?.front_image; // || defaultImages.front_image;
  const back_image = insurance?.back_image; // || defaultImages.back_image;
  const provider = insurance?.provider;
  const group = insurance?.group;
  const identifier = insurance?.identifier;
  const rx_bin_no = insurance?.rx_bin_no;
  const rx_pcn_no = insurance?.rx_pcn_no;

  const [showPreview, setShowPreview] = useState(false);
  const images = [front_image?.medium, back_image?.medium].filter(
    Boolean
  ) as string[];
  return (
    <Modal className={styles.modal} isOpen={isOpen} onClose={onClose}>
      <Card>
        <CardContent px="md" pt="sm" pb="sm">
          <div className={styles.header__title}>
            <Typography variant="h2">
              Insurance: {provider || insuranceId}
            </Typography>
          </div>
          <div className={styles.header__content}>
            {group && (
              <div className={styles.insurance_info}>
                <Typography variant="h3">Group: </Typography>
                <Typography variant="h3">{group}</Typography>
              </div>
            )}
            {identifier && (
              <div className={styles.insurance_info}>
                <Typography variant="h3">Identifier: </Typography>
                <Typography variant="h3">{identifier}</Typography>
              </div>
            )}
            {rx_bin_no && (
              <div className={styles.insurance_info}>
                <Typography variant="h3">Rx Bin No: </Typography>
                <Typography variant="h3">{rx_bin_no}</Typography>
              </div>
            )}
            {rx_pcn_no && (
              <div className={styles.insurance_info}>
                <Typography variant="h3">Rx PCN No: </Typography>
                <Typography variant="h3">{rx_pcn_no}</Typography>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
      <div className={styles.insurance_images}>
        {front_image?.medium && (
          <img
            className={styles.insurance_image}
            src={front_image?.medium}
            alt="Front"
            onClick={() => setShowPreview(true)}
          />
        )}
        {back_image?.medium && (
          <img
            className={styles.insurance_image}
            src={back_image?.medium}
            alt="Back"
            onClick={() => setShowPreview(true)}
          />
        )}
      </div>
      {showPreview && (
        <ImageView
          show={showPreview}
          images={images}
          onClose={() => setShowPreview(false)}
        />
      )}
    </Modal>
  );
}

export default InsuranceModal;
